import app from '@/app';
import templateUrl from './organization-search.html';

/* @ngInject */
function controller($controller, Organization, Principal, $state, $uibModal) {

  var $ctrl = this;
  $ctrl.currentAccount = null;
  
  Principal.identity().then(account => {
	$ctrl.currentAccount = account;
	})


	$controller('AbstractEntitySearchController', { $ctrl: this, resource: Organization });

	// Always the whole registry, never the current search: the export exists to be edited
	// and imported back.
	$ctrl.exportLink = '/api/organizations/export/excel';
	$ctrl.templateLink = '/api/organizations/template/excel';

	$ctrl.upload = files => {
		if (files && files.length) {
			$uibModal.open({
				component: 'organizationImportDialog',
				size: 'md',
				resolve: {
					files: () => files
				}
			}).result.then(() => $state.reload(), () => $state.reload());
		}
	};
}

const component = {
	templateUrl,
	controller,
	bindings: {
		$transition$: '<'
	}
};

app.component('organizationSearch', component);
